import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Eye, SkipForward, ScrollText } from "lucide-react";

const BIG = "h-16 px-7 rounded-2xl font-patient font-black text-xl inline-flex items-center gap-2 transition-colors active:scale-95";
const LETTERS = ["A", "B", "C"];

export const GROUP_MORALE = { id: "fable_morale", type: "fable_morale", title: "Complète la morale", description: "" };

function useMoraleQuiz(n) {
  const [rounds, setRounds] = useState(null);
  useEffect(() => {
    let ignore = false;
    api.get("/fables/morale-quiz", { params: { n } }).then((r) => !ignore && setRounds(r.data)).catch(() => !ignore && setRounds([]));
    return () => { ignore = true; };
  }, [n]);
  return rounds;
}

// Version groupe : l'animateur lit le début et les 3 fins, puis révèle la vraie morale.
export function GroupMorale({ onEnd }) {
  const rounds = useMoraleQuiz(10);
  const [n, setN] = useState(0);
  const [shown, setShown] = useState(false);
  if (!rounds) return <Loader2 className="w-8 h-8 animate-spin text-emerald-700 mx-auto" />;
  const r = rounds[n];
  if (!r) return <p className="text-xl font-patient text-gray-500 text-center py-10" data-testid="gmq-empty">Publiez des fables pour jouer.</p>;
  const next = () => (n + 1 < rounds.length ? (setN(n + 1), setShown(false)) : onEnd());
  return (
    <div className="rounded-3xl bg-white border-4 border-amber-100 p-8 text-center" data-testid="gmq-round">
      <p className="font-patient text-xl text-gray-500 mb-2" data-testid="gmq-progress">Fable {n + 1} sur {rounds.length} · « {r.fable} »</p>
      <p className="mx-auto max-w-3xl font-serif-display italic text-3xl sm:text-5xl leading-snug text-amber-950 mb-8 whitespace-pre-line" data-testid="gmq-start">{r.start} …</p>
      <div className="grid gap-3 max-w-3xl mx-auto mb-8 text-left" data-testid="gmq-options">
        {r.options.map((t, i) => (
          <div key={t} className={`rounded-2xl border-4 px-5 py-4 font-serif-display italic text-2xl sm:text-3xl flex gap-4 transition-colors ${shown && i === r.answer ? "border-emerald-400 bg-emerald-50" : shown ? "border-gray-100 opacity-40" : "border-amber-100"}`} data-testid={`gmq-option-${i}`}>
            <span className="font-patient not-italic font-black text-amber-600">{LETTERS[i]}</span><span>… {t}</span>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap justify-center gap-4">
        {!shown ? (
          <button onClick={() => setShown(true)} data-testid="gmq-reveal" className={`${BIG} bg-amber-400 hover:bg-amber-300 text-amber-950`}><Eye className="w-6 h-6" /> Révéler la vraie fin</button>
        ) : (
          <button onClick={next} data-testid="gmq-next" className={`${BIG} bg-emerald-700 hover:bg-emerald-800 text-white`}><SkipForward className="w-6 h-6" /> {n + 1 < rounds.length ? "Fable suivante" : "Terminer"}</button>
        )}
      </div>
    </div>
  );
}

export function MoraleCard({ onPick }) {
  const rounds = useMoraleQuiz(10);
  if (!rounds?.length) return null;
  return (
    <button onClick={() => onPick(GROUP_MORALE)} data-testid="gg-morale-card"
      className="w-full text-left rounded-3xl bg-orange-50 border-4 border-orange-200 hover:border-orange-300 p-5 transition-colors flex items-center gap-4">
      <span className="w-14 h-14 rounded-2xl bg-orange-500 flex items-center justify-center shrink-0"><ScrollText className="w-7 h-7 text-white" /></span>
      <span>
        <span className="block font-serif-display text-2xl text-orange-900">Complète la morale</span>
        <span className="block text-orange-800">{rounds.length} morales de La Fontaine : les résidents choisissent la bonne fin parmi 3, vous révélez la réponse.</span>
      </span>
    </button>
  );
}
